import { render, staticRenderFns } from "./NavSubHeader.vue?vue&type=template&id=2671abcc&scoped=true&lang=pug&"
import script from "./NavSubHeader.vue?vue&type=script&lang=js&"
export * from "./NavSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./NavSubHeader.vue?vue&type=style&index=0&id=2671abcc&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671abcc",
  null
  
)

export default component.exports